// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';
import { Action } from '@gandi/ui/deprecated';
import { Intro } from 'gandi.react-public-layout';

import { mapTags, useTranslator } from '@gandi/translate';

import styles from './AdditionalServices.scss';

type Props = {|
  phoneAdvisoryUrl: string,
  tmchUrl: string,
|};

function AdditionalServices({
  phoneAdvisoryUrl,
  tmchUrl,
}: Props): React.Element<typeof Intro> {
  const { __ } = useTranslator();

  return (
    <Intro title={__('Additional services')}>
      <Base marginBottom="base" className={styles.root}>
        <Base flex flexCol flexJustifyBetween>
          <Base
            flexBasis100
            padding="small"
            backgroundColor="grey-lighter"
            borderColor="grey-light"
            borderedBottom
          >
            <Base tagName="p" marginTop="none">
              {__('Need help with specific topics?')}
            </Base>
            <Base tagName="p" marginTop="none">
              {mapTags(
                __(
                  'No worries, you can ' +
                    '[[discuss: schedule a phone call with one of our experts]] ' +
                    'for help with bulk operations, portfolio management, domain name strategy, ' +
                    'or other topics of concern in the management of your products or online presence.'
                ),
                ({ discuss }) => ({
                  discuss: <strong>{discuss}</strong>,
                })
              )}
            </Base>
            <Base tagName="p" marginBottom="none">
              <a
                href={__(
                  'https://docs.gandi.net/en/domain_names/domain_services/phone_advisory.html'
                )}
                target="_blank"
                rel="noopener"
              >
                {__('See our documentation for details.')}
              </a>
            </Base>
          </Base>
          <Action icon="arrowRight" href={phoneAdvisoryUrl} variant="block">
            {__('Get expert advice from Gandi')}
          </Action>
        </Base>

        <Base flex flexCol flexJustifyBetween>
          <Base
            flexBasis100
            padding="small"
            backgroundColor="grey-lighter"
            borderColor="grey-light"
            borderedBottom
          >
            <Base tagName="p" marginTop="none">
              {__(
                'Register your trademark to the Trademark ClearingHouse database with Gandi. We take care about the complex part.'
              )}
              <br />
              {mapTags(
                __(
                  'Once your brand name is registered to the database, ' +
                    'you will be able to [[sunrisePhase: register the corresponding domain name on extensions in sunrise phase]], ' +
                    'for trademark only, ' +
                    "and you will [[beWarned: be warned for some time after the extension's general availability if someone tries to register a domain ]] " +
                    'with your brand name.'
                ),
                ({ sunrisePhase, beWarned }) => ({
                  sunrisePhase: <strong>{sunrisePhase}</strong>,
                  beWarned: <strong>{beWarned}</strong>,
                })
              )}
            </Base>
            <a
              href={__(
                'https://docs.gandi.net/en/domain_names/domain_services/tmch.html'
              )}
              target="_blank"
              rel="noopener"
            >
              {__('See our documentation for details.')}
            </a>
          </Base>
          <Action icon="arrowRight" href={tmchUrl} variant="block">
            {__('Register with TMCH')}
          </Action>
        </Base>
      </Base>
    </Intro>
  );
}

export default AdditionalServices;
